import React from "react";
import { Form, Switch } from "antd";
import { AttrTypeName } from "src/types/AttrType";
import {
  FormObjectSection,
  FormObjectSectionsStore,
} from "src/components/Forms/FormObjectSection";
import { observer } from "mobx-react-lite";
import { DrawTab } from "./DrawTab";
import {
  ZSchedSettingsTaskTemplate,
  ZSchedulingSettings,
} from "../../SchedulingTypes";
import { TaskTiesSection } from "./sections";
import { SchedulingObjType } from "../SchedulingSettingsStore";

interface PropsTaskTemplateFields {
  store: FormObjectSectionsStore<SchedulingObjType>;
}

const fieldName = (
  name: keyof ZSchedSettingsTaskTemplate,
): ["taskTemplateSettings", keyof ZSchedSettingsTaskTemplate] => [
  "taskTemplateSettings",
  name,
];

export const TaskTemplateFields: React.FC<PropsTaskTemplateFields> = observer(
  ({ store }) => (
    <DrawTab>
      <Form.Item
        name={fieldName("showByCondition")}
        label="Отображать шаблон в зависимости от состояния объекта"
      >
        <Switch />
      </Form.Item>
      <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
        store={store}
        objKey={fieldName("templateObjectId")}
        objType="taskTemplate"
        title="Объект: Шаблон задачи"
        attrTitle="Выберите атрибуты:"
        attrs={[
          {
            attrKey: fieldName("nameAttributeId"),
            attrLabel: "Название",
            attrType: AttrTypeName.string,
          },
          {
            attrKey: fieldName("durationAttributeId"),
            attrLabel: "Длительность",
            attrType: AttrTypeName.int,
          },
          {
            attrKey: fieldName("performerLinkAttributeId"),
            attrLabel: "Исполнитель",
            attrType: AttrTypeName.object,
          },
        ]}
      />
      <FormObjectSection<ZSchedulingSettings, SchedulingObjType>
        store={store}
        objKey={fieldName("templateObjectId")}
        objType="taskTemplate"
        attrTitle="Выберите атрибуты принадлежности задачи:"
        isObjSelect={false}
        attrs={[
          {
            attrKey: fieldName("groupAttributeId"),
            attrLabel: "К группе задач",
            attrType: AttrTypeName.object,
          },
          {
            attrKey: fieldName("divisionLinkAttributeId"),
            attrLabel: "К подразделению",
            attrType: AttrTypeName.object,
          },
        ]}
      />
      <TaskTiesSection
        objType="taskTemplateTies"
        tabKey="taskTemplateSettings"
        store={store}
        title="Объект: Привязки шаблонов задач"
      />
    </DrawTab>
  ),
);
